<template>
	<main class="main">
		<div class="main__page">
			<div class="card__header">
				<h2 class="main-title">{{ $t('interventionreport.title') }}</h2>
				<button class="btn" @click="showNewModal">
					{{ $t('common.new.title') }}
				</button>
			</div>
			<div class="card">
				<div class="card__detail">
					<form class="form" @submit.prevent="submitForm">
						<input type="hidden" v-model.trim="$v.form.user_id.$model">
						<input type="hidden" v-model.trim="$v.form.customer_id.$model">
						<div class="wizard_form">
							<div class="navigation_wizard">
								<div class="nav__step" v-for="step in 6" :id="`step${step}`" v-bind:key="step">
									<button class="step" @click="goStep(step)" type="button"
											:disabled="currentStep < step"
											v-bind:class="[{'inactive': currentStep > step}, {'current': currentStep == step}]">
										{{ $t(`interventionreport.steps.step${step}.title`)}}
									</button>
								</div>
							</div>
							<div class="steps">
								<!--
								***** STEP 1 *****
								** DATI CLIENTE **
								******************
								-->
								<div class="step" id="step1_form" v-show="currentStep == 1">
									<div class="form__field">
										<label class="form__field-label">{{$t('interventionreport.form.datainizio')}}</label>
										<input type="date" class="form__field-input"
											   v-model.trim="$v.form.datainizio.$model"/>
										<div class="field__validator_error"
											 v-if="submitted && !$v.form.datainizio.required">
											{{ $t('interventionreport.errors.datainizio_required') }}
										</div>
									</div>
									<div class="form__field">
										<label class="form__field-label">{{$t('interventionreport.form.datafine')}}</label>
										<input type="date" class="form__field-input"
											   v-model.trim="$v.form.datafine.$model"/>
										<div class="field__validator_error"
											 v-if="submitted && !$v.form.datafine.required">
											{{ $t('interventionreport.errors.datafine_required') }}
										</div>
									</div>
									<div class="form__field">
										<label class="form__field-label">{{$t('interventionreport.form.macchina')}}</label>
										<input class="form__field-input" v-model.trim="$v.form.macchina.$model"/>
									</div>
									<div class="form__field">
										<label class="form__field-label">{{$t('interventionreport.form.macchinanum')}}</label>
										<input class="form__field-input" v-model.trim="$v.form.macchinanum.$model"/>
									</div>
									<div class="form__field">
										<label class="form__field-label">{{$t('interventionreport.form.trasporto')}}</label>
										<select class="form__field-select" v-model.trim="$v.form.trasporto.$model">
											<option :value="m.key"
													v-for="m in $t(`interventionreport.steps.step1.mezzi`)"
													v-bind:key="m.key">
												{{ m.value }}
											</option>
										</select>
									</div>
									<h2 class="title">{{$t('interventionreport.steps.step1.subtitle')}}</h2>
									<div class="form__field">
										<label class="form__field-label">{{$t('interventionreport.form.customer.agency')}}</label>
										<input class="form__field-input" :disabled="form.customer_id != ''"
											   v-model.trim="$v.form.customer.agency.$model"/>
										<div class="field__validator_error"
											 v-if="submitted && !$v.form.customer.agency.required">
											{{ $t('interventionreport.errors.customer.agency_required') }}
										</div>
									</div>
									<div class="form__field">
										<label class="form__field-label">{{$t('interventionreport.form.customer.first_name')}}</label>
										<input class="form__field-input" :disabled="form.customer_id != ''"
											   v-model.trim="$v.form.customer.first_name.$model"/>
										<div class="field__validator_error"
											 v-if="submitted && !$v.form.customer.first_name.required">
											{{ $t('interventionreport.errors.customer.first_name_required') }}
										</div>
									</div>
									<div class="form__field">
										<label class="form__field-label">{{$t('interventionreport.form.customer.last_name')}}</label>
										<input class="form__field-input" :disabled="form.customer_id != ''"
											   v-model.trim="$v.form.customer.last_name.$model"/>
										<div class="field__validator_error"
											 v-if="submitted && !$v.form.customer.last_name.required">
											{{ $t('interventionreport.errors.customer.last_name_required') }}
										</div>
									</div>
									<div class="form__field">
										<label class="form__field-label">{{$t('interventionreport.form.customer.address')}}</label>
										<input class="form__field-input" :disabled="form.customer_id != ''"
											   v-model.trim="$v.form.customer.address.$model"/>
										<div class="field__validator_error"
											 v-if="submitted && !$v.form.customer.address.required">
											{{ $t('interventionreport.errors.customer.address_required') }}
										</div>
									</div>
									<div class="form__field">
										<label class="form__field-label">{{$t('interventionreport.form.customer.city')}}</label>
										<input class="form__field-input" :disabled="form.customer_id != ''"
											   v-model.trim="$v.form.customer.city.$model"/>
										<div class="field__validator_error"
											 v-if="submitted && !$v.form.customer.agency.required">
											{{ $t('interventionreport.errors.customer.city_required') }}
										</div>
									</div>
									<div class="form__field">
										<label class="form__field-label">{{$t('interventionreport.form.customer.vat_number')}}</label>
										<input class="form__field-input" :disabled="form.customer_id != ''"
											   v-model.trim="$v.form.customer.vat_number.$model"/>
									</div>
									<div class="form__field">
										<label class="form__field-label">{{$t('interventionreport.form.customer.email')}}</label>
										<input class="form__field-input" :disabled="form.customer_id != ''"
											   v-model.trim="$v.form.customer.email.$model"/>
									</div>
									<div class="form__field">
										<label class="form__field-label">{{$t('interventionreport.form.customer.email')}}
											2</label>
										<input class="form__field-input" :disabled="form.customer_id != ''"
											   v-model.trim="$v.form.customer.email2.$model"/>
									</div>
									<div class="form__field">
										<label class="form__field-label">{{$t('interventionreport.form.customer.email')}}
											3</label>
										<input class="form__field-input" :disabled="form.customer_id != ''"
											   v-model.trim="$v.form.customer.email3.$model"/>
									</div>

									<div class="form__field">
										<label class="form__field-label">Indirizzo sede</label>
										<input class="form__field-input" :disabled="form.customer_id != ''"
											   v-model.trim="$v.form.customer.sedi.indirizzo.$model"/>
									</div>

									<div class="form__field">
										<label class="form__field-label">Luogo sede</label>
										<input class="form__field-input" :disabled="form.customer_id != ''"
											   v-model.trim="$v.form.customer.sedi.luogo.$model"/>
									</div>

									<div class="controls-btns">
										<button class="btn light" @click="selectCustomer()" type="button">{{
											$t('interventionreport.form.customer.btn_seleziona_cliente') }}
										</button>
										<button class="btn" @click="nextStep()" type="button">{{ $t('common.next') }}
										</button>
									</div>
									<select-customer v-model="modalSelectClienteOpen"
													 @result="updateCustomerData($event)"></select-customer>
								</div>
								<!--
							   ***** STEP 2 *****
							   -->
								<div class="step" id="step2_form" v-show="currentStep == 2">
									<div class="form__field form__field_small yesnofield" v-for="ord in 7"
										 v-bind:key="ord">
										<label class="form__field-label form__field-label-small">{{$t(`interventionreport.form.ordine${ord}`)}}</label>
										<label class="yesno yesno-small"
											   v-bind:class="{'checked' : form[`ordine${ord}`] }" :for="`yesno${ord}`">
											<span class="option yes">Si</span> <span class="option no">No</span>
											<!-- <input type="checkbox" id="yesno" class="form__field-input" v-model.trim="$v.form.antincendio.$model"/> -->
											<input type="checkbox" :id="`yesno${ord}`" class="form__field-input"
												   v-model.trim="$v.form[`ordine${ord}`].$model"/>
										</label>
									</div>
									<!--<div class="form__field yesnofield">
										<label class="form__field-label">{{$t(`interventionreport.form.numddt`)}}</label>
										<label class="yesno" v-bind:class="{'checked' : form.numddt }" :for="`numddt`">
											<span class="option yes">Si</span>
											<span class="option no">No</span>
											<input type="checkbox" :id="`numddt`" class="form__field-input"
												   v-model.trim="$v.form.numddt.$model"/>
										</label>
									</div>
									<div class="form__field">
										<label class="form__field-label">{{$t('interventionreport.form.jsm')}}</label>
										<input class="form__field-input" v-model.trim="$v.form.jsm.$model"/>
									</div>-->
									<div class="form__field width100 marginTopBottom">
										<label class="form__field-label">{{$t('interventionreport.form.causale')}}</label>
										<select class="form__field-select" v-model.trim="$v.form.causale.$model">
											<option :value="m.key"
													v-for="m in $t(`interventionreport.steps.step2.causali`)"
													v-bind:key="m.key">
												{{ m.value }}
											</option>
										</select>
									</div>
									<div class="form__field yesnofield form__field_small">
										<label class="form__field-label form__field-label-small">{{$t(`interventionreport.form.reso`)}}</label>
										<label class="yesno yesno-small" v-bind:class="{'checked' : form.reso }"
											   :for="`reso`">
											<span class="option yes">Si</span> <span class="option no">No</span>
											<input type="checkbox" :id="`reso`" class="form__field-input"
												   v-model.trim="$v.form.reso.$model"/>
										</label>
										<!-- <input type="checkbox" class="form__field-input" v-model.trim="$v.form.reso.$model"/> -->
									</div>
									<div class="form__field yesnofield form__field_small">
										<label class="form__field-label form__field-label-small">{{$t(`interventionreport.form.garanzia`)}}</label>
										<label class="yesno yesno-small" v-bind:class="{'checked' : form.garanzia }"
											   :for="`garanzia`"> <span class="option yes">Si</span> <span
												class="option no">No</span>
											<input type="checkbox" :id="`garanzia`" class="form__field-input"
												   v-model.trim="$v.form.garanzia.$model"/>
										</label>
										<!-- <input type="checkbox" class="form__field-input" v-model.trim="$v.form.garanzia.$model"/> -->
									</div>
									<div class="form__field yesnofield form__field_small">
										<label class="form__field-label form__field-label-small">{{$t(`interventionreport.form.fatturare`)}}</label>
										<label class="yesno yesno-small" v-bind:class="{'checked' : form.fatturare }"
											   :for="`fatturare`"> <span class="option yes">Si</span> <span
												class="option no">No</span>
											<input type="checkbox" :id="`fatturare`" class="form__field-input"
												   v-model.trim="$v.form.fatturare.$model"/>
										</label>
										<!-- <input type="checkbox" class="form__field-input" v-model.trim="$v.form.fatturare.$model"/> -->
									</div>
									<div class="form__field yesnofield form__field_small">
										<label class="form__field-label form__field-label-small">{{$t(`interventionreport.form.contratto_manutenzione`)}}</label>
										<label class="yesno yesno-small"
											   v-bind:class="{'checked' : form.contratto_manutenzione }"
											   :for="`contratto_manutenzione`"> <span class="option yes">Si</span> <span
												class="option no">No</span>
											<input type="checkbox" :id="`contratto_manutenzione`"
												   class="form__field-input"
												   v-model.trim="$v.form.contratto_manutenzione.$model"/>
										</label>
										<!-- <input type="checkbox" class="form__field-input" v-model.trim="$v.form.contratto_manutenzione.$model"/> -->
									</div>
									<div class="form__field" v-if="form.contratto_manutenzione">
										<label class="form__field-label">{{$t('interventionreport.form.manutenzionenum')}}</label>
										<input class="form__field-input" v-model.trim="$v.form.manutenzionenum.$model"/>
									</div>
									<div class="form__field yesnofield"></div>
									<div class="form__field width100">
										<label class="form__field-label">{{$t('interventionreport.form.varie')}}</label>
										<textarea maxlength="1200" class="form__field-input"
												  v-model.trim="$v.form.varie.$model"></textarea>
										<small class="counter-textarea" v-if="form.varie">{{ form.varie.length }} /
											1200</small>
									</div>

									<div class="controls-btns">
										<button class="btn light" @click="prevStep()" type="button">{{ $t('common.back')
											}}
										</button>
										<button class="btn" @click="nextStep()" type="button">{{ $t('common.next') }}
										</button>
									</div>
								</div>
								<!--
							   ***** STEP 3 *****
							   -->
								<div class="step" id="step3_form" v-show="currentStep == 3">
									<div class="form__field width100">
										<label class="form__field-label">{{$t('interventionreport.form.note_cliente')}}</label>
										<textarea maxlength="175" class="form__field-input"
												  v-model.trim="$v.form.note_cliente.$model"></textarea>
									</div>
									<!--<div class="form__field"></div>
									<div class="form__field"></div>-->
									<div class="form__field width100">
										<label class="form__field-label">{{$t('interventionreport.form.annotazioni')}}</label>
										<input maxlength="150" class="form__field-input"
											   v-model.trim="$v.form.annotazioni.$model">
									</div>
									<div class="controls-btns">
										<button class="btn light" @click="prevStep()" type="button">{{ $t('common.back')
											}}
										</button>
										<button class="btn" @click="nextStep()" type="button">{{ $t('common.next') }}
										</button>
									</div>
								</div>
								<!--
							   ***** STEP 4 *****
							   -->
								<div class="step" id="step4_form" v-show="currentStep == 4">

									<div class="form__field yesnofield">
										<label class="form__field-label">{{$t(`interventionreport.form.numddt`)}}</label>
										<label class="yesno" v-bind:class="{'checked' : form.numddt }" :for="`numddt`">
											<span class="option yes">Si</span>
											<span class="option no">No</span>
											<input type="checkbox" :id="`numddt`" class="form__field-input"
												   v-model.trim="$v.form.numddt.$model"/>
										</label>
									</div>
									<div class="form__field">
										<label class="form__field-label">{{$t('interventionreport.form.jsm')}}</label>
										<input class="form__field-input" :disabled="ddtLoading" v-model.trim="$v.form.jsm.$model"/>

										<i v-if="ddtLoading" style="font-style: italic;">Caricamento numero DDT...</i>
										<select style="width: 90%; margin-top: 3px" v-if="$v.form.numddt.$model" class="form__field-select" v-model.trim="$v.form.code_type.$model">
											<option value="service">Schneeberger SERVICE</option>
											<option value="macchine">Schneeberger MACCHINE</option>
										</select>
									</div>
									<div class="form__field">
										<i v-if="!ddtLoading && ddtMessage !== ''" style="font-style: italic;" v-html="ddtMessage"></i>
									</div>

									<h2 v-if="$v.form.numddt.$model && $v.form.jsm.$model" class="title">Prodotti</h2>
									<span v-if="$v.form.numddt.$model && $v.form.jsm.$model" class="product__item"
										  v-for="(product, index) in $v.form.products.$model"
										  v-bind:key="index">
											<div class="form__field product__item-field">
												<label class="form__field-label">{{$t('interventionreport.form.products.cod')}}</label>
												<input maxlength="15" type="text" class="form__field-input"
													   v-model.trim="product.cod"/>
											</div>
											<div class="form__field product__item-field">
												<label class="form__field-label">{{$t('interventionreport.form.products.des')}}</label>
												<input maxlength="50" class="form__field-input"
													   v-model.trim="product.des"/>
											</div>
											<div class="form__field product__item-field">
												<label class="form__field-label">{{$t('interventionreport.form.products.qta')}}</label>
												<input type="number" class="form__field-input"
													   v-model.trim="product.qta"/>
											</div>
											<button class="btn light delete" type="button"
													@click="removeProductRow(index)">
												<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 54"><path
														d="M50 12.337h-4.449L42.078 52.07A2.107 2.107 0 0139.985 54H9.944a2.107 2.107 0 01-2.093-1.929L4.378 12.337H0v-4.23h14.636V3.525C14.636 1.581 16.207 0 18.137 0h13.726c1.93 0 3.501 1.581 3.501 3.525v4.582H50v4.23zM31.162 4.23H18.837v3.877h12.325V4.23zM8.596 12.337l3.272 37.433h26.193l3.272-37.433H8.596zm21.517 31.152l.911-25.026 4.199.155-.911 25.025-4.199-.154zM22.899 18.54h4.202v25.027h-4.202V18.54zm-8.122.077l4.198-.155.911 25.026-4.199.155-.91-25.026z"/></svg>
												<!-- {{$t('interventionreport.form.products.remove')}} -->
											</button>
										</span>
									<div class="controls-btns" v-if="$v.form.numddt.$model && $v.form.jsm.$model">
										<button v-if="form.products && Array.isArray(form.products) && form.products.length < 14"
												class="btn bordered" type="button" @click="addProductRow">
											{{$t('interventionreport.form.products.add')}} ({{ form.products.length }})
										</button>
									</div>

									<div class="controls-btns">
										<button class="btn light" @click="prevStep()" type="button">{{ $t('common.back')
											}}
										</button>
										<button class="btn" @click="nextStep()" type="button">{{ $t('common.next') }}
										</button>
									</div>

								</div>
								<!--
							   ***** STEP 5 *****
							   -->
								<div class="step" id="step5_form" v-show="currentStep == 5">

                                    <span class="hours__row"
										  v-for="row in Object.keys($t(`interventionreport.steps.step5.rows`))"
										  v-bind:key="row">
                                        <strong>{{ $t(`interventionreport.steps.step5.rows['${row}']`) }}</strong>
                                        <span class="days"
											  v-for="col in Object.keys($t(`interventionreport.steps.step5.days`))"
											  v-bind:key="col">
                                            <div class="form__field">
                                                <input type="number" class="form__field-input"
													   v-model.trim="$v.form[`${col}_${row}`].$model"/>
                                            </div>
                                            <small>{{ $t(`interventionreport.steps.step5.days['${col}']`) }}</small>
                                        </span>
                                    </span>
									<div class="controls-btns">
										<button class="btn light" @click="prevStep()" type="button">{{ $t('common.back')
											}}
										</button>
										<button class="btn" @click="nextStep()" type="button">{{ $t('common.next') }}
										</button>
									</div>
								</div>
								<!--
							   ***** STEP 6 *****
							   -->
								<div class="step" id="step6_form" v-show="currentStep == 6">
									<preview-data ref="preview" :structure="preview_structure"
												  :items="form"></preview-data>
									<signature-pad v-model="modalSignatureOpen"
												   @result="updateSignatureStatus($event)"></signature-pad>
									<div class="controls-btns">
										<button class="btn light" @click="prevStep()" type="button" :disabled="loading">
											{{ $t('common.back') }}
										</button>
										<button class="btn" @click="showSaveModal()" type="button" :disabled="loading">
											<span v-if="loading">{{ $t('common.loading') }}</span> <span
												v-if="!loading">
                                                <span>{{ $t('common.save') }}</span>
                                            </span>
										</button>
										<button class="btn" @click="openSignature()" type="button" :disabled="loading">

											<span v-if="loading">{{ $t('common.loading') }}</span> <span
												v-if="!loading">
                                                <span>{{ $t('common.saveAndSign') }}</span>
                                            </span>
										</button>
									</div>
								</div>
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>
		<confirm-modal v-model="modalNew" v-bind:title="$t('common.new.title')" v-bind:text="$t('common.new.message')"
					   @result="closeNewModal($event)"></confirm-modal>
		<confirm-modal v-model="modalSave" v-bind:title="$t('common.saveData.title')"
					   v-bind:text="$t('common.saveData.message')" @result="closeSaveModal($event)"></confirm-modal>
	</main>
</template>
<script>
    import {required} from 'vuelidate/lib/validators'
    import SelectCustomer from "../../components/SelectCustomerModal";
    import PreviewData from "../../components/AnteprimaComponent";
    import SignaturePad from "../../components/SignaturePadComponent";
    import moment from "moment-timezone";
    import ConfirmModal from "../../components/ConfirmModal";

    export default {
        name: 'intervention_reports_wizard_form',
        components: {
            ConfirmModal,
            SignaturePad,
            PreviewData,
            SelectCustomer
        },
        mounted() {
            this.preview_structure = this.api.intervention_reports.structureDoc;
            this.init();
        },
        data() {
            return {
                user: null,
                showError: false,
                error: '',
                loading: false,
                currentStep: 1,
                submitted: false,
                modalSelectClienteOpen: false,
                modalSignatureOpen: false,
                preview_structure: [],
                form: {},
                modalNew: false,
                modalSave: false,
				ddtMessage: '',
				ddtLoading: false
            }
        },
        watch: {
			'form.code_type': {
				handler() {
					this.ddtMessage = "";
					this.ddtLoading = true;
					this.api.intervention_reports.ddt.getNext(this.form.code_type)
						.then((result) => {
							this.form.jsm = result
						})
						.catch(() => {
							this.ddtMessage = "<br><br>Si è verificato un errore durante l'ottenimento del codice DDT. Il sistema non è nella rete.";
						})
						.finally(() => {
							this.ddtLoading = false;
						})
				},
				deep: false
			},
            'form': {
                handler() {
                    // salvo il dato
                    this.sync.tempData.update('intervention_report', this.form);

                    // controllo se il ddt è stato impostato su No, se è così cancello il JSM
                    if (this.form && this.form.numddt == false) {
						this.ddtLoading = false;
                        this.form.jsm = "";
						this.ddtMessage = "";
						this.form.code_type = "service";
                    } else {
						if(this.form.jsm == "") {
							this.ddtMessage = "";
							this.ddtLoading = true;
							this.api.intervention_reports.ddt.getNext(this.form.code_type)
								.then((result) => {
									this.form.jsm = result
								})
								.catch(() => {
									this.ddtMessage = "<br><br>Si è verificato un errore durante l'ottenimento del codice DDT. Il sistema non è nella rete.";
								})
								.finally(() => {
									this.ddtLoading = false;
								})
						} else {
							this.ddtMessage = "<br><br>Se il campo non è stato personalizzato, il numero DDT potrebbe cambiare";
						}
					}
                },
                deep: true
            },

        },
        // gestione della validazione
        validations: {
            form: {
                user_id: {
                    required
                },
                customer_id: {},
                datainizio: {
                    required
                },
                datafine: {
                    required
                },
                customer: {
                    agency: {
                        required
                    },
                    first_name: {
                        required
                    },
                    last_name: {
                        required
                    },
                    address: {
                        required
                    },
                    city: {
                        required
                    },
                    vat_number: {},
                    email: {},
                    email2: {},
                    email3: {},
					sedi: {
                        indirizzo: {},
						luogo: {}
					}
                },
                macchina: {},
                macchinanum: {},
                trasporto: {},
                ordine1: {},
                ordine2: {},
                ordine3: {},
                ordine4: {},
                ordine5: {},
                ordine6: {},
                ordine7: {},
                numddt: {},
                causale: {},
                jsm: {},
                reso: {},
                garanzia: {},
                fatturare: {},
                contratto_manutenzione: {},
                manutenzionenum: {},
                varie: {},
                note_cliente: {},
                annotazioni: {},
                products: {},
                lun_viaggio: {},
                mar_viaggio: {},
                mer_viaggio: {},
                gio_viaggio: {},
                ven_viaggio: {},
                sab_viaggio: {},
                dom_viaggio: {},
                lun_lavoro: {},
                mar_lavoro: {},
                mer_lavoro: {},
                gio_lavoro: {},
                ven_lavoro: {},
                sab_lavoro: {},
                dom_lavoro: {},
                lun_km: {},
                mar_km: {},
                mer_km: {},
                gio_km: {},
                ven_km: {},
                sab_km: {},
                dom_km: {},
                signature: {},
				sede: {},
				code: {},
				code_type: {}
            }
        },
        methods: {
            init() {
                this.initForm();
                this.sync.tempData.get('intervention_report')
                    .then((data) => {
                        if (data !== null) {
                            this.form = data;
                        }
                    });
            },
            initForm() {
                this.form = {
                    user_id: localStorage.getItem('user_id') || '',
                    customer_id: '',
                    datainizio: null,
                    datafine: null,
                    customer: {
                        agency: '',
                        first_name: '',
                        last_name: '',
                        address: '',
                        city: '',
                        vat_number: '',
                        email: '',
                        email2: '',
                        email3: '',
						sedi: {
                            indirizzo: '',
							luogo: ''
						}
                    },
                    macchina: '',
                    macchinanum: '',
                    trasporto: '',
                    ordine1: false,
                    ordine2: false,
                    ordine3: false,
                    ordine4: false,
                    ordine5: false,
                    ordine6: false,
                    ordine7: false,
                    numddt: false,
                    causale: '',
                    jsm: '',
                    reso: false,
                    garanzia: false,
                    fatturare: false,
                    contratto_manutenzione: false,
                    manutenzionenum: "",
                    varie: "",
                    note_cliente: "",
                    annotazioni: "",
                    products: [],
                    lun_viaggio: null,
                    mar_viaggio: null,
                    mer_viaggio: null,
                    gio_viaggio: null,
                    ven_viaggio: null,
                    sab_viaggio: null,
                    dom_viaggio: null,
                    lun_lavoro: null,
                    mar_lavoro: null,
                    mer_lavoro: null,
                    gio_lavoro: null,
                    ven_lavoro: null,
                    sab_lavoro: null,
                    dom_lavoro: null,
                    lun_km: null,
                    mar_km: null,
                    mer_km: null,
                    gio_km: null,
                    ven_km: null,
                    sab_km: null,
                    dom_km: null,
                    signature: "",
					sede: null,
					code: "",
					code_type: "service"
                };
            },
            showNewModal() {
                this.modalNew = !this.modalNew;
            },
            closeNewModal(res) {
                if (res) {
                    this.form = {};
                    this.initForm();
                    this.goStep(1);
                }
            },
            showSaveModal() {
				// controllo se il DDT è corretto
				// prendo il ddt e controllo se è un numero
				if(this.form.numddt) {
					this.form.jsm = this.form.jsm.trim();
					let year = new Date().getFullYear();
					let ddt = this.form.jsm.replace(year, ``);
					ddt = ddt.replace('/', ``);
					if(!isNaN(ddt)) {
						console.log(`E' un numero, controllo se esiste. Se esiste prendo il suo successivo`);
						this.api.intervention_reports.ddt.check(this.form.jsm, this.form.code_type)
							.then((resCheck) => {
								if(resCheck && resCheck.exist) {
									// esiste già, prendo un altro numero
									this.api.intervention_reports.ddt.getNext(this.form.code_type)
										.then((result) => {
											this.form.jsm = result
											this.modalSave = !this.modalSave;
										})
										.catch(() => {
											this.modalSave = !this.modalSave;
										})
										.finally(() => {
											this.ddtLoading = false;
										})
								} else {
									this.modalSave = !this.modalSave;
								}
							})
					} else {
						console.log(`Non è un numero, quindi è stato personalizzato`)
						this.modalSave = !this.modalSave;
					}
				} else {
					this.modalSave = !this.modalSave;
				}
            },
            closeSaveModal(res) {
                if (res) {
                    this.sync.tempData.addItem('intervention_report', this.form);
                    alert(`Elemento salvato con successo`);
                    this.$router.push({path: '/'});
                }
            },
            nextStep(products) {
                this.submitted = true;
                let errors = false;
                if (!this.$v.$invalid) {
                    // controllo i prodotti
                    if (this.currentStep == 4) {
                        // controllo i prodotti
                        if (this.form.products && Array.isArray(this.form.products) && this.form.products.length > 0) {
                            this.form.products.map((p) => {
                                if (!(p.des != "" && p.qta != "")) {
                                    errors = true;
                                }
                            })
                        }
                    }
                    if (!errors) {
                        this.currentStep++;
                        if (this.currentStep == 4 && Array.isArray(this.form.products) && this.form.products && this.form.products.length <= 0) {
                            //this.addProductRow();
                        }
                        this.$refs.preview.updateCells();
                    } else {
                        alert('Errore, Tutti i prodotti devono avere la quantità e la descrizione completata.');
                    }
                } else {
                    alert('Errore, controllare i dati prima di procedere.');
                }

				this.api.intervention_reports.code.getNext()
					.then(code => {
						this.form.code = code;
					})
            },
            prevStep() {
                if (this.currentStep > 1)
                    this.currentStep -= 1;
                this.$refs.preview.updateCells();
            },
            goStep(step) {
                this.currentStep = step;
                this.$refs.preview.updateCells();
            },
            addProductRow() {
                if (this.form.products && Array.isArray(this.form.products) && this.form.products.length <= 14) {
                    this.form.products.push({
                        'cod': '',
                        'des': '',
                        'qta': ''
                    });
                }
            },
            removeProductRow(index) {
                this.form.products.splice(index, 1);
                if (this.form.products.length <= 0) {
                    // this.addProductRow();
                }
            },
            /** Apre la modale per la selezione del customer */
            selectCustomer() {
                this.modalSelectClienteOpen = !this.modalSelectClienteOpen;
            },
            /** Apre la firma per la chiusura del modulo */
            openSignature() {
				if(this.form.numddt) {
					// controllo se il DDT è corretto
					// prendo il ddt e controllo se è un numero
					this.form.jsm = this.form.jsm.trim();
					let year = new Date().getFullYear();
					let ddt = this.form.jsm.replace(year, ``);
					ddt = ddt.replace('/', ``);

					this.api.intervention_reports.code.getNext()
						.then(code => {
							this.form.code = code;
						})

					if(!isNaN(ddt)) {
						console.log(`E' un numero, controllo se esiste. Se esiste prendo il suo successivo`);
						this.api.intervention_reports.ddt.check(this.form.jsm, this.form.code_type)
							.then((resCheck) => {
								if(resCheck && resCheck.exist) {
									// esiste già, prendo un altro numero
									this.api.intervention_reports.ddt.getNext(this.form.code_type)
										.then((result) => {
											this.form.jsm = result
											this.modalSignatureOpen = !this.modalSignatureOpen;
										})
										.catch(() => {
											this.modalSignatureOpen = !this.modalSignatureOpen;
										})
										.finally(() => {
											this.ddtLoading = false;
										})
								} else {
									this.modalSignatureOpen = !this.modalSignatureOpen;
								}
							})
					} else {
						console.log(`Non è un numero, quindi è stato personalizzato`)
						this.modalSignatureOpen = !this.modalSignatureOpen;
					}
				} else {
					this.modalSignatureOpen = !this.modalSignatureOpen;
				}
            },
            /** Eseguita la firma mi metto, salvo la form */
            updateSignatureStatus(data) {
                if (data !== false) {
                    this.form.signature = data;
                    this.submitForm();
                }
            },
            /** Sistemazione del customer */
            updateCustomerData(data) {
                console.log(`Selezionato`, data);
                this.form.customer_id = '';
                this.form.customer.agency = '';
                this.form.customer.first_name = '';
                this.form.customer.last_name = '';
                this.form.customer.address = '';
                this.form.customer.city = '';
                this.form.customer.vat_number = '';
                this.form.customer.email = '';
                this.form.customer.email2 = '';
                this.form.customer.email3 = '';
                this.form.customer.sedi = {
					indirizzo: "",
					luogo: ""
                };
                if (data && data !== false && data !== null) {
                    this.form.customer_id = data.id;
                    this.form.customer.agency = data.agency;
                    this.form.customer.first_name = data.first_name;
                    this.form.customer.last_name = data.last_name;
                    this.form.customer.address = data.address;
                    this.form.customer.city = data.city;
                    this.form.customer.vat_number = data.vat_number;
                    this.form.customer.email = data.email;
                    this.form.customer.email2 = data.email2;
                    this.form.customer.email3 = data.email3;
                    this.form.customer.sedi = data.sedi;
                }
                this.form.sede = {...this.form.customer.sedi};
            },
            /** Salvo i dati */
            saveData(frm) {
                // salvo offline
                frm.id = this.helpers.generateNewUUID();
                frm.updated_at = frm.created_at = moment().tz("Europe/Rome").format("YYYY-MM-DD kk:mm:ss");
                frm.deleted_at = null;
                delete frm.data_salvataggio;
                // salvo nella lista dei rapporti di intervento salvati
                this.sync.tempData.addItem('intervention_report', this.form);
                this.api.intervention_reports.offline.add(frm)
                    .then(() => {
                        // se è tutto ok, procedo con la sincronizzazione
                        if (navigator.onLine) {
                            this.sync.syncronizeTable('customers', (updated) => {
                                if (updated == 'end') {
                                    this.sync.syncronizeTable('intervention_reports', (updated) => {
                                        this.initForm();
                                        if (updated == 'end') {
                                            this.toast.success(this.$t(`interventionreport.save_complete`));
                                            this.$router.push({path: '/'});
                                        }
                                        if (updated == 'error') {
                                            // fine sincronizzazione
                                            this.toast.info(this.$t(`interventionreport.save_without_sync`));
                                            this.$router.push({path: '/'});
                                        }
                                    });
                                }
                            });
                        } else {
                            this.sync.tempData.remove('intervention_report');
                            this.toast.info('Nessuna connessione internet. Il report sarà inviato alla prossima sincronizzazione.');
                            this.$router.push({path: '/'});
                            this.loading = false;
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        this.loading = false;
                    });
            },
            /** Invio la form */
            submitForm() {
                this.$v.$touch();
                if (!this.$v.$invalid) {
                    this.loading = true;
                    // sistemazione della form
                    let frm = {...this.form};
                    frm.ordine1 = (this.form.ordine1 == true) ? 1 : 0;
                    frm.ordine2 = (this.form.ordine2 == true) ? 1 : 0;
                    frm.ordine3 = (this.form.ordine3 == true) ? 1 : 0;
                    frm.ordine4 = (this.form.ordine4 == true) ? 1 : 0;
                    frm.ordine5 = (this.form.ordine5 == true) ? 1 : 0;
                    frm.ordine6 = (this.form.ordine6 == true) ? 1 : 0;
                    frm.ordine7 = (this.form.ordine7 == true) ? 1 : 0;
                    frm.numddt = (this.form.numddt == true) ? 1 : 0;
                    frm.reso = (this.form.reso == true) ? 1 : 0;
                    frm.garanzia = (this.form.garanzia == true) ? 1 : 0;
                    frm.fatturare = (this.form.fatturare == true) ? 1 : 0;
                    frm.sede = {...frm.customer.sedi};
                    // controllo se esiste il customer_id
                    // se non esiste creo il dato nel database
                    if (frm.customer_id.trim() == "") {
                        let c = {...frm.customer};
                        c.id = this.helpers.generateNewUUID();
                        c.updated_at = c.created_at = moment().tz("Europe/Rome").format("YYYY-MM-DD kk:mm:ss");
                        c.deleted_at = null;
                        let aT = [];
                        aT.push(c.sedi);
						c.sedi = aT;
                        this.api.customers.offline.add(c)
                            .then((customer_id) => {
                                frm.customer_id = customer_id;
                                delete frm.customer;
                                this.saveData(frm);
                            })
                            .catch((err) => {
                                // TODO: Sistemare l'errore
                                console.log(err);
                            });
                    } else {
                        delete frm.customer;
                        this.saveData(frm);
                    }
                } else {
                    this.loading = false;
                }
            }
        }
    }
</script>
<style lang="scss">
	@import './src/scss/variables';

	.product__item {
		display: flex;
		flex-wrap: wrap;
		width: 100%;
		@extend %flexCenterEnd;

		.delete {
			background: $red !important;
			@include size(var(--icons) !important, var(--icons) !important);
			margin-bottom: var(--gutter);

			svg {
				@include size(100%, 100%);
				fill: $white;
			}
		}

		@media (min-width: 1000px) {
			&-field {
				width: 29%;
				margin: calc(var(--gutter) / 2) 1%;
			}
			.delete {
				margin-top: 35px;
				@include size(55px !important, 55px !important);
				margin-bottom: 0;

				svg {
					@include size(90%, 90%);
				}
			}
		}
	}

	.width100 {
		width: 100% !important;

		textarea {
			width: 710px;
			height: 210px;
		}
	}

	.marginTopBottom {
		margin: 20px 0;
	}

	.hours__row {
		display: flex;
		flex-wrap: wrap;
		padding-bottom: var(--gutter);

		strong {
			display: block;
			width: 100%;
			font-weight: $bold;
			font-size: 1.1em;
			/*margin-bottom: 15px;*/
		}

		.days {
			width: calc(100% / 7);

			small {
				display: block;
				width: 100%;
				font-size: 0.8em;
				text-transform: uppercase;
				text-align: center;
			}

			.form__field {
				justify-content: center;
				width: 100%;
			}
		}
	}

	.counter-textarea {
		width: 100%;
		margin-top: 10px;
		color: #888888;
		font-size: 10px;
	}
</style>
